import { createSlice } from "@reduxjs/toolkit";
import staticGamesData from "../../assets/static.json";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { postRequest } from "../../services/apiCaller/cl_index";

const initialState = {
  depositResponse: '',
  loader: false,

};
const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setDepositRes: (state, action) => {
      state.depositResponse = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});
export const { setDepositRes, setLoader } =
  paymentSlice.actions;
export default paymentSlice.reducer;

export const handleDepositAPI = (
  amount,
  userNumber,
  userId,
  userEmail,
  countryCode,
  clientId,
  sessionId,
  firsDepositCheck,
  userCurrency,
  userType
) => async (dispatch) => {
  dispatch(setLoader(true));
  const url = endpoints?.deposit;
  const token = getFromLocalStorage("gk");
  const payload = {
    accessToken: token,
    amount: amount,
    clientType: "mobile",
    countryCode,
    email: userEmail,
    mobileOperator: "MPESA",
    msisdn: userNumber,
    paymentOperator: "MPESA",
    paymentType: "CARD",
    pin: "1234",
    userId: userId + "",
    clientId,
    sessionId
  };

  // Store payment params for chat API context
  try {
    localStorage.setItem('fasfas_payment_params', JSON.stringify(payload));
    console.log('[DEPOSIT] ✅ Payment params stored:', payload);
  } catch (e) {
    console.error('[DEPOSIT] ❌ Failed to store payment params:', e);
  }

  return postRequest(url, payload)
    .then((res) => {
      dispatch(setLoader(false));
      const body = res?.data;
      const isSuccess =
        res?.status === 200 &&
        body?.code === "1000" &&
        body?.statusCode === 200 &&
        body?.result?.data?.message === "DEPOSIT_SUCCESS";

      if (isSuccess) {
        dispatch(setDepositRes("Deposit request placed successfully"));
        // Clear payment params after success
        try { localStorage.removeItem('fasfas_payment_params'); } catch (e) {}
        return Promise.resolve({ status: "success", res: body });
      } else {
        dispatch(setDepositRes("Deposit request failed please try again later"));
        // Clear payment params on error
        try { localStorage.removeItem('fasfas_payment_params'); } catch (e) {}
        return Promise.reject({ status: "fail", res: body });
      }
    })
    .catch(() => {
      dispatch(setLoader(false));
      dispatch(setDepositRes("Deposit request failed please try again later"));
      // Clear payment params on error
      try { localStorage.removeItem('fasfas_payment_params'); } catch (e) {}
      return Promise.reject("fail");
    });
};


